import React from 'react';
import Icon from './Icon';
import * as IconModule from './Icon';

// Get all icon names from the icons object in Icon.jsx
const iconNames = Object.keys(IconModule.default?.icons || IconModule.icons || {});

const fallbackIconNames = [
  'upload', 'check', 'close', 'user', 'image', 'search', 'edit', 'trash', 'plus', 'minus',
  'arrow-left', 'arrow-right', 'star', 'heart', 'info', 'warning', 'settings', 'lock', 'unlock',
  'eye', 'eye-off', 'calendar', 'bell', 'mail', 'phone', 'home',
  // Add new icons here if dynamic import fails
  'link', 'list', 'location', 'login', 'logout', 'map', 'maximize', 'menu', 'message', 'microphone',
  'moon', 'more', 'move', 'music', 'navigation', 'octagon', 'package', 'paperclip', 'pause', 'pen',
  'percent', 'play', 'power', 'printer', 'radio', 'refresh', 'repeat', 'rewind', 'rocket', 'rss',
  'save', 'scissors', 'send', 'server'
];

const iconsToShow = iconNames.length > 0 ? iconNames : fallbackIconNames;

const IconDemo = () => (
  <div style={{
    minHeight: '100vh',
    background: `
      linear-gradient(135deg, #667eea 0%, #764ba2 100%),
      radial-gradient(circle at 20% 80%, #f093fb 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, #f5576c 0%, transparent 50%),
      radial-gradient(circle at 40% 40%, #4facfe 0%, transparent 50%)
    `,
    backgroundBlendMode: 'overlay, screen, screen, screen',
    padding: '40px 20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '32px',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }}>
    <h2 style={{ color: 'white', fontSize: '2rem', margin: 0 }}>Icon Demo</h2>
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
      gap: '32px',
      width: '100%',
      maxWidth: 900,
      justifyItems: 'center',
      alignItems: 'center',
      background: 'rgba(255,255,255,0.07)',
      borderRadius: '18px',
      padding: '32px 24px',
      boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
    }}>
      {iconsToShow.map(name => (
        <div key={name} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <Icon name={name} size={40} color="#fff" />
          <span style={{ color: 'white', fontSize: '0.95rem', marginTop: 4 }}>{name}</span>
        </div>
      ))}
    </div>
  </div>
);

export default IconDemo; 